export const CLOUD_ICONS = [
  { src: '/img/icons/aws-icon.svg', alt: 'AWS' },
  { src: '/img/icons/gcp-icon.svg', alt: 'Google Cloud' },
  { src: '/img/icons/azure-icon.svg', alt: 'Azure' },
]

export const CONTAINER_ICONS = [
  { src: '/img/icons/docker-icon.svg', alt: 'Docker' },
  { src: '/img/icons/kubernetes-icon.svg', alt: 'Kubernetes' },
]

export const POPULAR_TOOLS_ICONS = [
  { src: '/img/icons/heroku-icon.svg', alt: 'Heroku' },
  { src: '/img/icons/fluentd-icon.svg', alt: 'Fluentd' },
  { src: '/img/icons/vercel-icon.svg', alt: 'Vercel' },
  { src: '/img/icons/redis-icon.svg', alt: 'Redis' },
  { src: '/img/icons/mongo-icon.svg', alt: 'Mongo' },
  { src: '/img/icons/nginx-icon.svg', alt: 'Nginx' },
]

export const EXISTING_AGENTS_ICONS = [
  { src: '/img/icons/fluentd-icon.svg', alt: 'Fluentd' },
  { src: '/img/icons/fluentbit-icon.svg', alt: 'Fluentbit' },
  { src: '/img/icons/logstash-icon.svg', alt: 'Logstash' },
]

export const DIRECT_INTEGRATIONS = ['HTTP Endpoints', 'SDK Integrations', 'Legacy support']
